import { CooperBotActivityLogState } from '@pages/cooper-bot-activity-log/store/states/cooper-bot-activity-log.state';

export const cooperBotActivityLogState = [CooperBotActivityLogState];
